import { notification, Pagination, Row, Typography } from "antd";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import ButtonRectangle from "@/components/ButtonRectangle";
import TableCustom from "@/components/TableCustom";
import styles from "../../clientCUR.module.less";
import { Toast, useTypedDispatch, useTypedSelector } from "@/app/store";
import { dialogUserCURSlide } from "@/modules/DialogUserCUR/dialogUserCUR.slice";
import { useDeleteUserMutation, useGetUserListQuery } from "@/rtk-query/userQueries";
import { userColumns } from "../../clientCUR.constants";
import { checkTotalAllItem, getError, useCheckPermission } from "@/utils/helpers";
import C from "@/utils/constants";
import message from "@/utils/message";

const { Title } = Typography;

function UserList() {
  const params: any = useParams();
  const dispatch = useTypedDispatch();
  const { updateClientCURState } = dialogUserCURSlide.actions;
  const [page, setPage] = useState(1);
  const [users, setUsers] = useState<any[]>([]);

  const { userInfo }  = useTypedSelector((store) => store.dashboardLayoutSlide)
  const canEditUser = useCheckPermission(C.PERMISSIONS.USER_EDIT);
  const canDeleteUser = useCheckPermission(C.PERMISSIONS.USER_DELETE);
  const { currentData, isFetching: isFetchingUserList } = useGetUserListQuery(
    {
      companyId: params?.id,
      page,
      pageSize: C.PAGE_SIZE_LITTLE,
      isLoading: undefined,
    },
    {
      skip: !params?.id,
    }
  );
  const [deleteUserApi] = useDeleteUserMutation();

  const handleOpenUpdateUser = (type: "create" | "edit", id?: string | number) => {
    dispatch(
      updateClientCURState({
        type,
        id,
        isOpen: true,
        companyId: params?.id,
      })
    );
  };

  const deleteUserFnc = async (id: number | string) => {
    try {
      await deleteUserApi({ id }).unwrap();
      notification.success({
        key: "user_del",
        message: message.SUCCESSFULLY,
      });
    } catch (err) {
      notification.error({
        key: "user_del",
        message: getError(err),
      });
    }
    Toast.close();
  };

  const handleDeleteUser = (id: string | number) => {
    Toast.delete({
      isOpen: true,
      title: "Are you sure you want to delete this user?",
      description: "You will not able to view and edit this user’s information.",
      cancelText: "Cancel",
      okText: "Delete",
      onCancel: () => {
        Toast.close();
      },
      onOk: () => deleteUserFnc(id),
      okStyle: {
        background: "#F32121",
      },
    });
  };

  useEffect(() => {
    const data = currentData?.data.filter((user) => user.deletedAt === null);
    setUsers(data || []);
  }, [isFetchingUserList]);

  return (
    <>
      <div className={styles.listUserHeader}>
        <Title
          level={5}
          style={{
            color: "#234C66",
            margin: 0,
          }}
        >
          LIST OF USERS
        </Title>
        <ButtonRectangle
          style={{
            height: 36,
          }}
          onClick={() => handleOpenUpdateUser("create")}
        >
          Add new user
        </ButtonRectangle>
      </div>

      <div className={styles.listUserContent}>
        <TableCustom
          columns={userColumns({
            onEdit: handleOpenUpdateUser,
            onDelete: handleDeleteUser,
            canEditUser,
            canDeleteUser,
            userInfo
          })}
          data={users || []}
          loading={isFetchingUserList}
          total={checkTotalAllItem({ page })}
        />
        {(currentData?.totalPage || 0) > 1 && (
          <Row
            justify="end"
            style={{
              marginTop: 24,
            }}
          >
            <Pagination
              current={page}
              total={currentData?.totalPage || 0}
              pageSize={1}
              onChange={(page) => {
                setPage(page);
              }}
              showSizeChanger={false}
            />
          </Row>
        )}
      </div>
    </>
  );
}

export default UserList;
